import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import PersonIcon from "@mui/icons-material/Person";
import MailIcon from "@mui/icons-material/Mail";
import Button from "../../SubComponents/Button/Button";
import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import { useState } from "react";
import "./FormStyle.css";
export default function Form() {
  const [submitStatus, setSubmitStatus] = useState(false);
  const form = useRef();

  const sendEmail = async (e) => {
    e.preventDefault();

    await emailjs
      .sendForm(
        "service_a2wxkul",
        "template_j2zbxyi",
        form.current,
        "mjTRYCJoJrushs600"
      )
      .then(
        () => {
          setSubmitStatus(true);
        },
        (error) => {
          console.log(error.text);
        }
    );
    
  };

  return (
    <div className="form-root">
      {submitStatus && (
        <div className="after-submit-div">
          <p className="heading-after-submit">Sent successfully !</p>

          <p className="desc-after-submit">
            Your message is sent successfully ! I will be in touch with you
            super soon.
          </p>
          <img
            src="./paper-plane.png"
            className="img-after-submit"
            alt="paper-plane"
            
          />
         
        </div>
      )}
      {!submitStatus && (
        <Box
          ref={form}
          onSubmit={sendEmail}
          method="POST"
          target="_parent"
          component="form"
          autoComplete="off"
          sx={{
            "& .MuiTextField-root": { m: 1 },
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
          className="box-div"
        >
          <div className="form-container">
            <FormControl
              sx={{ m: 1, minWidth: "100%" }}
              fullwidth="true"
              variant="outlined"
              required
            >
              <InputLabel
                required
                htmlFor="outlined-adornment-name"
                style={{ color: "white" }}
                name="name"
              >
                Name
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-name"
                required
                startAdornment={
                  <InputAdornment position="start">
                    {<PersonIcon style={{ color: "grey" }} />}
                  </InputAdornment>
                }
                style={{ color: "white" }}
                label="Name"
                type="text"
                name="user_name"
              />
            </FormControl>
            <FormControl
              fullwidth="true"
              variant="outlined"
              sx={{ m: 1, minWidth: "100%" }}
            >
              <InputLabel
                type="email"
                required
                htmlFor="outlined-adornment-email"
                style={{ color: "#5ee0f6" }}
              >
                Email
              </InputLabel>
              <OutlinedInput
                required
                id="outlined-adornment-email"
                type="email"
                name="user_email"
                style={{ color: "white" }}
                startAdornment={
                  <InputAdornment position="start">
                    {<MailIcon style={{ color: "grey" }} />}
                  </InputAdornment>
                }
                label="Email"
              />
            </FormControl>
            <FormControl>
              <TextField
                id="standard-multiline-static"
                label="Message"
                name="message"
                multiline
                required
                fullWidth
                rows={4}
                sx={{ minWidth: "100%" }}
                variant="outlined"
                InputProps={{
                  style: { color: "white" },
                  startAdornment: (
                    <InputAdornment
                      disableTypography
                      position="end"
                    ></InputAdornment>
                  ),
                }}
              />
            </FormControl>
            <div className="submit-btn-div">
              <Button type="submit" value="Send">
                Submit
              </Button>
            </div>
          </div>
          <div></div>
        </Box>
      )}
    </div>
  );
}
